<div class="toast-container">
  @for (toast of toasts$ | async; track toast) {
    <div
      class="toast"
      [class]="'toast-' + toast.type"
      (click)="removeToast(toast.id)"
      (keydown.enter)="removeToast(toast.id)"
      >
      <span class="toast-icon">{{ getIcon(toast.type) }}</span>
      <span class="toast-message">{{ toast.message }}</span>
    </div>
  }
</div>
